<template>
  <div>
    Facebook Login
  </div>
</template>

<script>
export default {
  created() {
    let token = null;

    if(window.location.hash) {
      let hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
      if(hash.match(new RegExp('access_token' + '=([^&]*)')))
      {
        token = hash.match(new RegExp('access_token' + '=([^&]*)'))[0].split('=')[1];
      }
    }

    if(token)
    {
      this.$store.dispatch('externalLoginFacebook', token)
    }
    else{
      this.$store.dispatch('mostrarMensaje', 
          { 
            imagen: 'emo-sad',
            titulo: 'No fue posible ingresar con Facebook',
            contenido: 'No fue posible ingresar con tu cuenta de Facebook, intenta nuevamente.',
            boton: {
              ruta: { name: 'facebook-login-url' },
              etiqueta: 'Reintentar'
            },
            enlace1: {
              ruta: { name: 'login' },
              etiqueta: 'Si ya te has registrado ingresa aquí.'
            },
            enlace2: {
              ruta: { name: 'register' },
              etiqueta: 'O regístrate con otro método aquí.'
            }     
          })
    }
  }
}
</script>